<template>
  <div class="alert" :class="[variant]">
    <div class="icon">
      <exclamation-icon />
    </div>
    <p class="flex flex-col">
      <span class="text-table-header !text-current">
        {{ title }}
      </span>
      <span v-if="subTitle" class="table-neutral">
        {{ subTitle }}
      </span>
    </p>
  </div>
</template>

<script lang="ts" setup>
import ExclamationIcon from '@images/exclamation.svg?component';

export type AlertVariant = 'error' | 'warn' | 'info';

interface Props {
  variant?: AlertVariant;
  title: string;
  subTitle?: string;
}

withDefaults(defineProps<Props>(), {
  variant: 'info',
});
</script>

<style lang="scss" scoped>
.alert {
  @apply flex items-center gap-x-7.5 pl-4 pr-7.5 py-6;
  @apply border border-element-neutral;
  @apply rounded-4;
  @apply bg-white;
  @apply text-neutral;

  .icon {
    @apply w-13 h-13 p-2;
    @apply rounded-full ring-8 ring-offset-1 ring-info-blue-10 ring-inset;
    flex: 0 0 auto;

    & > * {
      @apply w-full h-full;
    }
  }

  &.error {
    @apply text-red-130;
    @apply bg-red-5;
    @apply border-primary;

    .icon {
      @apply ring-red-10;
      @apply bg-white;

      :deep(path) {
        fill: theme("colors.red.120");
      }
    }
  }

  &.warn {
    @apply text-yellow-300;
    @apply bg-yellow-10;
    @apply border-yellow;

    .icon {
      @apply ring-yellow;
      @apply bg-white;

      :deep(path) {
        fill: theme("colors.yellow.300");
      }
    }
  }
}
</style>
